import { isSubscribed } from "@data/utility/dataUtils"
import { isBlockOn, TENANT_BLOCKS } from "@data/utility/tenantBlocks"
import React from "react"
import { connect } from "react-redux"

import { ParentHomeScreen } from "../../../ports/primary/ui/screens/parent/ParentHome/ParentHomeScreen"
import { useJoinLiveAsChild } from "./useJoinLiveAsChild"
import { useTutorSlotMoveLink } from "./useTutorSlotMoveLink"

/**
 * Enveloppe legacy de l'accueil ports — porte « Ajouter un cours ponctuel » et « Rejoindre ».
 *
 * Le formulaire est `<ExtraHoursFlow>` (design system), monté par l'écran ports lui-même ;
 * l'enveloppe ne lui descend que la garde.
 *
 * Même garde qu'aujourd'hui : `extraHourEnabled = !!student && isSubscribed(student)`
 * (`StudentLiveSessionsList`). Elle descend en `addOneOffLessonDisabled` : la tuile appartient à
 * une rangée de quatre gestes, alors elle reste à sa place, grisée, plutôt que de laisser un trou.
 *
 * « Rejoindre en tant que … » suit la même règle : la bascule de compte et l'intention de
 * navigation vivent dans `src/common/**` (`useJoinLiveAsChild`), que `ports/**` n'importe pas —
 * l'écran ne reçoit qu'un rappel, et son absence éteint la ligne.
 */
const ParentHomeWithExtraHours = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { student, currentUser, dispatch, ...screenProps } = props
    // Bloc éteint dans l'espace de l'élève : pas de tuile du tout, ni grisée.
    const extraHourOffered = isBlockOn(currentUser, TENANT_BLOCKS.EXTRA_HOURS)
    const extraHourEnabled =
        extraHourOffered && !!student && isSubscribed(student)
    const { joinLiveAsChild } = useJoinLiveAsChild()
    const tutorSlotMoveLink = useTutorSlotMoveLink(props)

    return (
        <ParentHomeScreen
            {...screenProps}
            addOneOffLessonDisabled={!extraHourEnabled}
            addOneOffLessonHidden={!extraHourOffered}
            onJoinAsChild={joinLiveAsChild}
            {...tutorSlotMoveLink}
        />
    )
}

const mapStateToProps = (state) => ({
    student: state.data.formData?.user,
    currentUser: state.data.currentUser?.object,
})

export default connect(mapStateToProps)(ParentHomeWithExtraHours)
